import { baseConf } from '@config/base'
import type { Config } from '@config/prod'

export const conf: Config = {
  ...baseConf,
  api: {
    auth: 'https://auth.ppgr.io/auth/v3',
    signin: 'https://pp-sh.io/auth/signin',
    signup: 'https://pp-sh.io/auth/signup',
  },
  domains: {
    cookie: '.pp-sh.io',
    controlPlaneCookie: '.ppgr.io',
    main: 'pp-sh.io',
    grammarly: 'ppgr.io',
    coda: 'staging.coda.io',
  },
  sessionTransfer: {
    toCoda: 'https://staging.coda.io/v1/mediator/initiate',
    toGrammarly: 'https://auth.ppgr.io/v1/mediator/initiate',
  },
  thirdPartyConfig: {
    ...baseConf.thirdPartyConfig,
    transcend: {
      // id: '6beaafdb-ad13-4a71-bbf9-467debfba53d',
      id: '1c1f8e90-47d0-4bba-a1a2-472d59b002a2', // ToDo remove after testing
    },
  },
  tracking: {
    ...baseConf.tracking,
    gnar: {
      // TODO (tusharc): change back to gnar.ppgr.io before going live
      // Refer https://grammarly.slack.com/archives/C02270EFMA9/p1758645743671299?thread_ts=1758639264.679989&cid=C02270EFMA9
      // gnar.qagr and gnar.ppgr no longer supported
      // we need to send all events to gnar.grammarly.com
      url: 'https://gnar.grammarly.com',
    },
    shLegacyTracking: {
      ...baseConf.tracking.shLegacyTracking,
      enabled: true,
    },
  },
  paths: {
    ...baseConf.paths,
    basePath: 'https://pp-sh.io',
    nomos: {
      ...baseConf.paths.nomos,
      basePath: 'https://settings.pp-sh.io',
    },
  },
}
